import React from 'react';
import {
    usePropertyFetching,
    usePropertyPresentation,
} from '../../../../contextsProperty/ContextProperties';
import Card from '../../../../../muiComponents/Card';
import GridChild from '../../../../../muiComponents/GridChild';
import Grid from '../../../../../muiComponents/Grid';
import Image from '../../../../components/Image';
import {
    gridColumnsSpacing,
    gridRowsSpacing,
    imageColumnGrid,
} from '../../../../../utils/property/propertyUtils';
import LoadingPlaceholder from '../../../../../muiComponents/LoadingPlaceholder';
import { ImageState } from '../../../../../types/properties/propertyTypes';

const ImagesSection = () => {
    const { images } = usePropertyPresentation();
    const { isFetching } = usePropertyFetching();

    const displayImages: (ImageState | null)[] = [...images];
    while (displayImages.length < 4) {
        displayImages.push(null);
    }

    return (
        <>
            {images.length ? (
                <section>
                    <Card className='flex padding20'>
                        {isFetching ? (
                            <LoadingPlaceholder
                                variant='rounded'
                                width={'100%'}
                                height={200}
                            />
                        ) : (
                            <Grid
                                columnSpacing={gridColumnsSpacing}
                                rowSpacing={gridRowsSpacing}
                                style={{ width: 'unset' }}
                            >
                                {displayImages.map((img, ind) => (
                                    <GridChild
                                        gridProps={imageColumnGrid}
                                        key={img?.id || ind}
                                    >
                                        <Image
                                            className='completed-presentation__image'
                                            src={img?.url || ''}
                                            useLocalBaseUrl={false}
                                        />
                                    </GridChild>
                                ))}
                            </Grid>
                        )}
                    </Card>
                </section>
            ) : (
                ''
            )}
        </>
    );
};

export default ImagesSection;
